const ONE_DAY = 86400000;

export const GET_PREMIUM_ACCESS_URL = 'https://web.diffit.me/plans';
const FREE_TRIAL_LENGTH_DAYS = 14;
export const setExtendWithSchoolOpen = (searchParams, setSearchParams) => {
  searchParams.set('extend_with_school', true);
  setSearchParams(searchParams);
};

export const userHasEnteredSchoolRecord = (diffitUser) => {
  if (!diffitUser) {
    return false;
  }
  return diffitUser.has_school_record;
};

export const userHasCompletedTrialExtensionSurvey = (diffitUser) => {
  if (!diffitUser) {
    return false;
  }
  let seenNux = diffitUser.seen_nux_json ? diffitUser.seen_nux_json : {};
  return !!seenNux['submitted_trial_extension_survey'];
};

export const userCanExportActivity = ({ activity, isPremiumUser }) => {
  if (!activity) {
    return true;
  }
  return isPremiumUser || activity?.is_premium === false || activity?.is_free_this_month === true;
};

export const isFreeTrialOver = (diffitUser) => {
  if (!diffitUser) return false;
  return diffitUser.is_free_trial_over;
};

export const isInPremiumOrg = (diffitUser) => {
  // Check the subscription end date of each org the user is in
  // If any of them are in the future, the user is premium
  if (!diffitUser) return false;
  return diffitUser.is_in_premium_org;
};

export const isActiveIndividualSubscription = (diffitUser) => {
  if (!diffitUser) return false;
  return diffitUser.is_active_individual_subscription;
};

export const isInPremiumDomain = (diffitUser) => {
  if (!diffitUser) return false;
  return diffitUser.is_in_premium_domain;
};

export const isAmbassador = (diffitUser) => {
  if (!diffitUser) return false;
  return diffitUser.is_ambassador;
};

export const hasActiveSubscription = (diffitUser) => {
  return (
    isInPremiumOrg(diffitUser) ||
    isActiveIndividualSubscription(diffitUser) ||
    isInPremiumDomain(diffitUser) ||
    isAmbassador(diffitUser)
  );
};

export const isFreeTrialUser = (clerkUser, diffitUser) => {
  if (!clerkUser) return false;
  if (diffitUser) {
    return diffitUser.is_free_trial;
  }
  const now = Date.now();
  // If the user was created in the past day, they're premium
  // There's a small gap between creating the user in Clerk and then updating on the backend, so give the benefit of the doubt
  if (clerkUser.createdAt > now - ONE_DAY) {
    return true;
  }
  return false;
};

export const isPremiumUser = (user, diffitUser) => {
  return hasActiveSubscription(diffitUser) || isFreeTrialUser(user, diffitUser);
};

export const daysLeftInTrial = (clerkUser, diffitUser) => {
  if (!clerkUser) return null;
  if (diffitUser) {
    return diffitUser.days_left_in_trial;
  }

  const now = Date.now();

  // If the user was created in the past day, they have FREE_TRIAL_LENGTH_DAYS days left in their trial
  // There's a small gap between creating the user in Clerk and then updating on the backend, so give the benefit of the doubt
  if (clerkUser.createdAt > now - ONE_DAY) {
    const daysLeft = FREE_TRIAL_LENGTH_DAYS;
    return daysLeft;
  }
  return null;
};

// Derive a single categorical subscription status for analytics. Priority
// order mirrors the backend is_paid/is_premium precedence (paid sources
// before trial). Returns null when there's no known Diffit user.
export const getSubscriptionStatus = (diffitUser) => {
  if (!diffitUser) return null;
  if (isActiveIndividualSubscription(diffitUser)) return 'paid_individual';
  if (isInPremiumOrg(diffitUser)) return 'premium_org';
  if (isInPremiumDomain(diffitUser)) return 'premium_domain';
  if (diffitUser.is_free_trial) return 'free_trial';
  if (diffitUser.is_free_trial_over) return 'trial_expired';
  return 'free';
};
